var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0003 8.5L5.73669 22.5566L20.3788 29.6356C21.1569 30.0117 22.0886 29.8456 22.6886 29.2237L34.0003 17.5L23.6445 28.7187C22.7919 29.6424 22.9927 31.1143 24.0615 31.7759L37.011 39.7912L44.0003 8.5Z",
    stroke: "#DED2CC",
    strokeWidth: 3.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramOutlined);
export default __webpack_public_path__ + "static/media/telegram_outlined.f014863d65b3decd8aa1279c28f86850.svg";
export { ForwardRef as ReactComponent };